import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Button from '../../../components/common/Button';
import CheckBoxField from '../../../components/common/CheckBoxField';
import Preloader from '../../../components/common/Preloader';
import { accountDetailsRequest } from '../../../modules/account/actions';
import { getConsents, isDetailsPending } from '../../../modules/account/selectors';
import { SETTINGS } from '../../../routes/paths';
import Translation from '../../i18n/Translation';
import { consentsSaveRequest } from './actions';

export class MarketingPreferences extends Component {
  constructor(props) {
    super(props);
    this.cancelHandler = this.cancelHandler.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.submitConsents = this.submitConsents.bind(this);
    this.initialConsents = {
      marketing: !!props.consents.marketing
    };
    this.state = {
      submitDisabled: true,
      consents: this.initialConsents
    };
  }

  componentDidMount() {
    this.props.onLoad();
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      consents: {
        marketing: !!nextProps.consents.marketing
      }
    });
  }

  cancelHandler() {
    const { history } = this.props;
    history.push(SETTINGS);
  }

  handleChange(id, checked) {
    this.setState(prevState => {
      let submitDisabled = false;
      const updatedConsents = {
        ...prevState.consents,
        [id]: checked
      };

      if (updatedConsents.marketing === this.initialConsents.marketing) {
        submitDisabled = true;
      }

      return ({
        consents: updatedConsents,
        submitDisabled
      });
    });
  }

  submitConsents() {
    const { saveConsents } = this.props;

    saveConsents({
      marketing: !!this.state.consents.marketing
    }, 'settings');
  }

  render() {
    const { consents, submitDisabled } = this.state;
    const { checkingState } = this.props;

    if (checkingState) {
      return (
        <div className="login-consents">
          <div className="login-consents__preloader">
            <Preloader>
              <Translation section="linkingAccounts" label="checking" />
            </Preloader>
          </div>
        </div>
      );
    }

    return (
      <div className="marketing-preferences container--fixed">
        <h1 className="marketing-preferences__title">Marketing Preferences</h1>
        <h2 className="marketing-preferences__subtitle">Current Consent Permissions:</h2>
        <div className="marketing-preferences__consents">
          <CheckBoxField
            className="marketing-preferences__checkbox"
            id="marketing"
            onChange={this.handleChange}
            checked={consents.marketing}
          >
            By ticking this box you agree to receive direct marketing about William Hill’s
            gambling services, free bets and other promotions. You can opt-out at any time.
          </CheckBoxField>
        </div>
        <Button
          className="marketing-preferences__button"
          onClick={this.submitConsents}
          disabled={submitDisabled}
        >
          Update
        </Button>
        <Button
          className="marketing-preferences__button button--secondary"
          onClick={this.cancelHandler}
        >
          Return to account settings
        </Button>
      </div>
    );
  }
}

MarketingPreferences.propTypes = {
  consents: PropTypes.object.isRequired,
  checkingState: PropTypes.bool,
  history: PropTypes.object.isRequired,
  saveConsents: PropTypes.func.isRequired,
  onLoad: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  checkingState: isDetailsPending(state),
  consents: getConsents(state)
});

const mapDispatchToProps = {
  saveConsents: consentsSaveRequest,
  onLoad: accountDetailsRequest
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MarketingPreferences));
